import {useCallback, useState} from "react";
import {
	SelectField,
	InputField,
	SelectUserAll
} from "~/components/Forms";
import {useCan} from "~/hooks";
import {CAREERS} from "../../../../app/constants";

function CreatedWebsiteSearchBar({filter, onSearchChange, onChange}) {

	const can = {
		listAll  : useCan('createdWebsiteListAll'),
		listGroup: useCan('createdWebsiteListGroup'),
	}

	const careerOptions = [
		{ value: '', label: 'Tất cả ngành nghề' },
		...CAREERS
	];

	const trashOptions = [
		{ value: 0, label: 'Đang chạy' },
		{ value: 1, label: 'Thù rác' },
	];

	const [optionsUser, setOptionsUser] = useState([{value:'', label:'Tất cả nhân viên'}]);

	const handleKeywordChange = (e) => {
		if (!onSearchChange) return;
		const newFilter = {
			...filter,
			keyword: e.target.value,
			page: 1,
		};
		onSearchChange(newFilter);
	}

	const handleCareerChange = useCallback((value) => {
		if(onChange) onChange('career', value);
	}, [onChange]);

	const handleTrashChange = useCallback((value) => {
		if(onChange) onChange('trash', value);
	}, [onChange]);

	const handleUserChange = useCallback((value) => {
		if(onChange) onChange('userId', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<InputField defaultValue={filter.keyword} placeholder="Đường dẫn" onChange={handleKeywordChange} />
					<SelectField placeholder="Ngành nghề" options={careerOptions} onChange={handleCareerChange}/>
					<SelectField placeholder="Loại" options={trashOptions} onChange={handleTrashChange}/>
					{(can.listAll || can.listGroup) && <SelectUserAll value={filter.userId} placeholder="Nhân viên" options={optionsUser} setOptions={setOptionsUser} onChange={handleUserChange} />}
				</form>
			</div>
		</div>
	)
}

export default CreatedWebsiteSearchBar;
